var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('SetNewForgotPassword',{on:{"on-send-clicked":function($event){return _vm.sendRequestChangePassword($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }